import { PasswordStrengthScore } from "./types";

export const MAX_SCORE = PasswordStrengthScore.great;
export const MIN_ACCEPTABLE_SCORE = PasswordStrengthScore.good;
export const MIN_PASSWORD_LENGTH = 12;
